import React, { useMemo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import MessageInput from 'supportAssistant/components/Chat/MessageInput'
import { isChip } from 'supportAssistant/utils/actionsUtils'
import Action from 'supportAssistant/components/Chat/MessageMeta/Action'

const CenterContainer = styled(Group)`
  height: calc(100dvh - ${rem(60)} - ${rem(1)});
  padding-top: ${rem(16)};
  padding-bottom: ${rem(16)};

  ${mediaQueryUp.tablet} {
    padding-top: 0;
    padding-bottom: 0;
  }
`

const InputContainer = styled.div`
  width: 100%;
  max-width: ${rem(720)};
`

const ActionsContainer = styled.div`
  width: 100%;
  max-width: ${rem(720)};
`

interface Props {
  isTyping: boolean
  actions?: Array<App.ChatMessageMetaContent>
  payload?: App.ChatMessageMetaPayload
  className?: string
}

function ChatEmptyState(props: Props) {
  const { isTyping, actions, payload, className } = props

  const chipActions = useMemo(() => actions?.filter(isChip) ?? [], [actions])

  return (
    <CenterContainer className={className} direction="vertical" horizontalAlign="center" verticalAlign="center" gap={16} fullWidth>
      <HeadingTextBlock variant="heading4" align="center">
        How can we help you?
      </HeadingTextBlock>

      <InputContainer>
        <MessageInput isTyping={isTyping} />
      </InputContainer>

      {chipActions.length > 0 && (
        <ActionsContainer>
          <Group
            direction="horizontal"
            tabletDirection="horizontal"
            wrap="wrap"
            horizontalAlign="center"
            verticalAlign="center"
            gap={8}
            fullWidth
          >
            {chipActions.map((action, index) => (
              <Action action={action} key={`${action.text}-${index}`} payload={payload} />
            ))}
          </Group>
        </ActionsContainer>
      )}
    </CenterContainer>
  )
}

export default ChatEmptyState
